import type { Param } from 'shared/search-adapters'

import Tag from 'components/atoms/Tag'
import { memo, useState } from 'react'

import css from './Tags.module.scss'
import { usePrepareTags } from './usePrepareTags'

function FilterTags_({
	order
}: {
	order: Param[]
}) {
	const { clearAllFilters, tags } = usePrepareTags(order)

	const [showAll, setShowAll] = useState(false)
	const showedTags = showAll ? tags : tags.slice(0, 2)
	const shouldShowMoreButton = tags.length > 2 && !showAll

	if (tags.length === 0) {
		return null
	}

	return (
		<div className={css.root}>
			<div className={css.wrap}>
				{showedTags.map(({ clear, key, text }) => (
					<Tag key={key} onClick={clear} text={text} type='small' />
				))}
			</div>
			<div className={css.controls}>
				{shouldShowMoreButton && (
					<>
						<button
							className={css.button}
							onClick={() => setShowAll(true)}
							type='button'
						>
							Show more
						</button>
						<div className={css.divider} />
					</>
				)}
				{tags.length > 0 && (
					<button
						className={css.button}
						onClick={clearAllFilters}
						type='button'
					>
						Clear all
					</button>
				)}
			</div>
		</div>
	)
}

export const FilterTags = memo(FilterTags_)
